const getUserAgent = () => {
    try {
        return window.navigator.userAgent;
    }
    catch (e) {
        return '';
    }
};
const agentIdentities = () => {
    const userAgent = getUserAgent();
    return {
        Safari: userAgent.includes('Safari'),
        Chrome: userAgent.includes('Chrome'),
        Chromium: userAgent.includes('Chromium'),
        CriOS: userAgent.includes('CriOS'),
        FxiOS: userAgent.includes('FxiOS'),
        Edge: userAgent.includes('Edg'),
        Opera: userAgent.includes('OP'),
    };
};
const isIpadPlatform = () => {
    try {
        // @ts-expect-error
        return window.navigator.platform === 'MacIntel' && typeof window.navigator.standalone !== 'undefined';
    }
    catch (_a) {
        return false;
    }
};
export const isSafari = () => {
    const { Safari, Chrome, CriOS, FxiOS } = agentIdentities();
    return Safari && !Chrome && !CriOS && !FxiOS;
};
export const isChromium = () => {
    const { Chrome, Chromium } = agentIdentities();
    return Chrome || Chromium;
};
export const getChromiumVersion = () => {
    const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : null;
};
export const isUnsupportedBrowser = () => {
    if (isChromium()) {
        const version = getChromiumVersion();
        return !!version && version < 74;
    }
    return false;
};
export const isIOS = () => {
    return /iPhone|iPad/i.test(getUserAgent()) || isIpadPlatform();
};
//# sourceMappingURL=browsers.js.map